export default {
  title: 'Importuj stanowiska z {dataSource}',
  importWorkplaces: 'Importuj stanowiska',
  next: 'Dalej',
  previous: 'Wstecz',
  import: 'Importuj stanowiska',
  retry: 'Ponów',
  userMapping: {
    header: 'Mapowanie użytkowników',
    description: 'Qmulus odczytuje stanowiska za pomocą Twojego użytkownika PT9800 i synchronizuje zaimportowane stanowiska za pomocą użytkownika PT9800 użytkownika systemowego.',
    currentUser: 'Twój użytkownik PT9800',
    systemUser: 'Użytkownik PT9800 użytkownika systemowego',
    loadWorkplacesFailed: 'Nie można załadować stanowisk',
    workplacesUnauthorized: 'PT9800 nie zaakceptował Twojego użytkownika PT9800. Wybierz użytkownika PT9800 z dostępem do tej bazy danych.',
    loadFailed: 'Nie można załadować mapowania użytkowników',
    saveFailed: 'Nie można zapisać mapowania użytkowników',
    currentUserMissing: {
      summary: 'Twój użytkownik nie jest przypisany do użytkownika PT9800',
      details: 'Poproś administratora użytkowników o przypisanie Twojego użytkownika do użytkownika PT9800 w zarządzaniu użytkownikami, a następnie ponownie otwórz import.',
    },
    systemUserReason: {
      summary: 'Dlaczego użytkownik systemowy potrzebuje użytkownika PT9800',
      details: 'Qmulus synchronizuje w tle wsady, sygnały, alarmy i receptury zaimportowanych stanowisk jako użytkownik systemowy. Bez użytkownika PT9800 dla użytkownika systemowego zaimportowane stanowiska pozostaną puste.',
    },
    systemUserUnknown: {
      summary: 'Sprawdź mapowanie użytkownika systemowego',
      details: 'Zaimportowane stanowiska są synchronizowane tylko wtedy, gdy użytkownik systemowy jest przypisany do użytkownika PT9800. Poproś administratora użytkowników o sprawdzenie tego w zarządzaniu użytkownikami.',
    },
  },
  location: {
    header: 'Lokalizacja',
    description: 'Wybierz lokalizację, do której zostaną zaimportowane stanowiska.',
    linkedToOtherDataSource: {
      summary: 'Lokalizacja należy do innej instalacji PT9800',
      details: 'Ta lokalizacja jest już połączona z {dataSources}. Sprawdź, czy wybrano właściwą lokalizację.',
    },
    notLinked: {
      summary: 'Lokalizacja zostanie połączona',
      details: 'Import połączy tę lokalizację z {dataSource}.',
    },
  },
  workplaces: {
    header: 'Stanowiska',
    empty: 'Ta instalacja PT9800 nie ma stanowisk, które można zaimportować.',
    nameRequired: 'Wprowadź nazwę.',
    licenseExceeded: '{level}: brak wolnych licencji. Licencja pozwala na {allowed}.',
    licenseLimitReached: 'Osiągnięto limit licencji',
    licenseUsage: '{level}: wykorzystano {used} z {allowed} licencji, łącznie z wybranymi stanowiskami.',
  },
  state: {
    waiting: 'Oczekuje',
    importing: 'Importowanie',
    imported: 'Zaimportowano',
    failed: 'Niepowodzenie',
    alreadyImported: 'Już zaimportowano',
  },
  progress: {
    current: 'Krok {current} z {total}: {step}',
    finished: 'Import zakończony',
    failed: 'Niepowodzenie: {step}',
    step: {
      linkLocation: 'Łączenie lokalizacji „{name}” ze źródłem danych',
      createAsset: 'Tworzenie „{name}”',
      loadChambers: 'Ładowanie komór „{name}”',
      linkAsset: 'Łączenie „{name}” ze źródłem danych',
    },
  },
};
